import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ProtectedRoute from './components/ProtectedRoute';
import WriterDashboard from './pages/writer-dashboard';
import About from './pages/about';
import Homepage from './pages/homepage';
import AboutDawaaer from './pages/about-dawaaer';
import Signup from './pages/signup';
import VerifyEmail from './pages/verify-email';
import ArticleReading from './pages/article-reading';
import CreatorStudio from './pages/creator-studio';
import UserProfile from './pages/user-profile';
import Settings from './pages/settings';
import ArticleEngagementHub from './pages/article-engagement-hub';
import DiscussionCircle from './pages/discussion-circle';
import DiscussionsFeed from './pages/discussions-feed';
import PolicyPage from './pages/policy';
import CirclesPage from './pages/circles-directory';
import EditorialQueueDashboard from './pages/admin/dashboard';
import AdminArchive from './pages/admin/archive';
import AdminSettings from './pages/admin/settings';
import AdminAnalytics from './pages/admin/settings/analytics';
import AdminAdmins from './pages/admin/settings/admins';
import PublicUserProfile from './pages/public-user-profile';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Public routes */}
        <Route path="/" element={<Homepage />} />
        <Route path="/homepage" element={<Homepage />} />
        <Route path="/about" element={<About />} />
        <Route path="/about-dawaaer" element={<AboutDawaaer />} />
        {/* Redirect old URL for production compatibility */}
        <Route path="/about-dawayer" element={<Navigate to="/about-dawaaer" replace />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/article/:id/engagement" element={<ArticleEngagementHub />} />
        <Route path="/article/:id" element={<ArticleReading />} />
        <Route path="/discussion/:id" element={<DiscussionCircle />} />
        <Route path="/discussions-feed" element={<DiscussionsFeed />} />
        <Route path="/policy" element={<PolicyPage />} />
        <Route path="/circles" element={<CirclesPage />} />
        <Route path="/user/:id" element={<PublicUserProfile />} />

        {/* Protected routes */}
        <Route path="/writer-dashboard" element={<ProtectedRoute><WriterDashboard /></ProtectedRoute>} />
        <Route path="/creator-studio" element={<ProtectedRoute><CreatorStudio /></ProtectedRoute>} />
        <Route path="/creator-studio/:id" element={<ProtectedRoute><CreatorStudio /></ProtectedRoute>} />
        <Route path="/user-profile" element={<ProtectedRoute><UserProfile /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />

        {/* Admin Routes */}
        <Route path="/admin/dashboard" element={<EditorialQueueDashboard />} />
        <Route path="/admin/archive" element={<AdminArchive />} />
        <Route path="/admin/settings" element={<AdminSettings />} />
        <Route path="/admin/settings/analytics" element={<AdminAnalytics />} />
        <Route path="/admin/settings/admins" element={<AdminAdmins />} />

        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
